export default __webpack_public_path__ + "static/media/SDG-icon-NL-02.fe85a433.svg";